import { Injectable } from '@angular/core';

import { SidebarService } from './side-bar.service';
import { TaskBarService } from './task-bar.service';

@Injectable()
export class MobileMenuService {
  isAccountMenuOpen = false;
  private mobileBreakpoint = 1024;

  constructor(
    private sidebarService: SidebarService,
    private taskbarService: TaskBarService
  ) {}

  isMobile(): boolean {
    return window.innerWidth <= this.mobileBreakpoint;
  }

  toggleAccountMenu(): void {
    if (!this.isMobile()) {
      return;
    }
    const nextState = !this.isAccountMenuOpen;
    this.setSidebarOpen(false);
    this.setTaskbarOpen(false);
    this.isAccountMenuOpen = nextState;
  }

  toggleSidebar(): void {
    if (this.isMobile()) {
      const nextState = !this.sidebarService.isOpen;
      this.isAccountMenuOpen = false;
      this.setTaskbarOpen(false);
      this.setSidebarOpen(nextState);
      return;
    }
    this.sidebarService.openSideBar();
  }

  toggleTaskbar(): void {
    if (this.isMobile()) {
      const nextState = !this.taskbarService.isOpen;
      this.isAccountMenuOpen = false;
      this.setSidebarOpen(false);
      this.setTaskbarOpen(nextState);
      return;
    }
    this.taskbarService.openTaskBar();
  }

  closeAccountMenu(): void {
    this.isAccountMenuOpen = false;
  }

  closeAll(): void {
    this.isAccountMenuOpen = false;
    if (!this.isMobile()) {
      return;
    }
    this.setSidebarOpen(false);
    this.setTaskbarOpen(false);
  }

  hasOpenMobileLayer(): boolean {
    if (!this.isMobile()) {
      return false;
    }
    return this.isAccountMenuOpen || this.sidebarService.isOpen || this.taskbarService.isOpen;
  }

  private setSidebarOpen(isOpen: boolean): void {
    this.sidebarService.setSideBar(isOpen);
    localStorage.setItem('NavBar', String(isOpen));
  }

  private setTaskbarOpen(isOpen: boolean): void {
    this.taskbarService.setTaskBar(isOpen);
    localStorage.setItem('TaskBar', String(isOpen));
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/mobile-menu.service.ts